import { Latest } from './ui/Latest.jsx'
import './ui/Latest.scss'

export default Latest
